import { createRoute } from "@tanstack/solid-router";
import { lazy, Suspense } from "solid-js";
import { appRoute } from "./route";

const ActivityFeedPage = lazy(async () => {
  const m = await import("@/features/activity/components/activity-feed-page");
  return { default: m.ActivityFeedPage };
});

/**
 * ACTIVITY-CORE (L3) — "who did what" feed for the account and its organizations.
 * Stockpilot variant: stock adjustments ALWAYS with actor + reason and
 * corrections as explicit reversing moves (ERP requirement).
 */
export const activityRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/activity",
  component: () => (
    <Suspense fallback={null}>
      <ActivityFeedPage />
    </Suspense>
  ),
});
